/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Docs} from 'components/layout';
import {getIntegrations} from 'api/get-integrations';
import {getExtensions} from 'api/get-extensions';
import {Warning, Tip, Info, WhitelistDetails} from 'ui';
export const title = "Breakdowns", description = "Hightouch's Campaign Intelligence Breakdowns lets you slice your customer data on any user attribute, such as location, LTV, brand affinity, etc.", lastUpdatedDate = new Date(1718150400000);
export async function getStaticProps() {
  const integrations = await getIntegrations();
  const extensions = await getExtensions();
  return {
    props: {
      ...integrations,
      extensions,
      meta: {
        title: "Breakdowns",
        description: "Hightouch's Campaign Intelligence Breakdowns lets you slice your customer data on any user attribute, such as location, LTV, brand affinity, etc.",
        lastUpdatedDate: "Wed Jun 12 2024 00:00:00 GMT+0000 (Coordinated Universal Time)",
        slug: null,
        type: null,
        icon: null,
        toc: [{
          "value": "Overview",
          "depth": 0,
          "id": "overview"
        }]
      }
    },
    revalidate: 60
  };
}
const MDXLayout = ({children, ...props}) => _jsx(Docs, Object.assign({}, props, {
  children: children
}));
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      p: "p",
      a: "a",
      h2: "h2",
      img: "img"
    }, _provideComponents(), props.components);
    return _jsxs(_Fragment, {
      children: [_jsx(Info, {
        children: _jsxs(_components.p, {
          children: ["Campaign Intelligence is available as an add-on on ", _jsx(_components.a, {
            href: "https://hightouch.com/pricing",
            children: "Business tier plans"
          }), "."]
        })
      }), "\n", _jsx(_components.h2, {
        id: "overview",
        children: "Overview"
      }), "\n", _jsx(_components.p, {
        children: "Breakdowns enable you to view any event or metric aggregated over time and broken down by any user or event property."
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "hightouch-audiences/analytics/breakdowns.png",
          alt: "Analytics breakdowns"
        })
      })]
    });
  }
}
export default MDXContent;
